// extracted by mini-css-extract-plugin
export var addFilterSection = "facultypage-module--addFilterSection--spuzQ";
export var bannerPinkBtn = "facultypage-module--bannerPinkBtn--ffoRy";
export var benefitsSection = "facultypage-module--benefitsSection--QRX74";
export var bgColor = "facultypage-module--bgColor--frMaw";
export var card = "facultypage-module--card--R44KJ";
export var cardContent = "facultypage-module--cardContent--EVv+d";
export var cardImg = "facultypage-module--cardImg--+ZkxT";
export var cardInfo = "facultypage-module--cardInfo--dkJ9z";
export var cardList = "facultypage-module--cardList--uXRiD";
export var catalogueContainer = "facultypage-module--catalogueContainer--pjOLh";
export var catalogueList = "facultypage-module--catalogueList--XVxRq";
export var catalogueMenu = "facultypage-module--catalogueMenu--+CTsC";
export var catalogueMenuBody = "facultypage-module--catalogueMenuBody--6STKz";
export var catalogueSection = "facultypage-module--catalogueSection---vyOh";
export var categoryBottomInfo = "facultypage-module--categoryBottomInfo--wzRdc";
export var categoryInfo = "facultypage-module--categoryInfo--EA-65";
export var check = "facultypage-module--check--Le0fO";
export var checkInfo = "facultypage-module--checkInfo--tAWJt";
export var courseBenefitsHeader = "facultypage-module--course-benefits-header--GdwLQ";
export var courseDescription = "facultypage-module--courseDescription--j+2ui";
export var courseName = "facultypage-module--courseName--c-fh7";
export var displaySyle = "facultypage-module--displaySyle--6MoZc";
export var endOfList = "facultypage-module--endOfList--1zioR";
export var endSectionHeading = "facultypage-module--endSectionHeading--nX9g7";
export var enrollCount = "facultypage-module--enrollCount--V-r8u";
export var enrollSection = "facultypage-module--enrollSection--abRMS";
export var facultyPageContainer = "facultypage-module--facultyPageContainer--1WNZR";
export var filterBtn = "facultypage-module--filterBtn--9sBM1";
export var filterContainer = "facultypage-module--filterContainer--iiPXH";
export var filterSelected = "facultypage-module--filterSelected--FPKGX";
export var floatingDropdown = "facultypage-module--floatingDropdown--G2+kH";
export var grid = "facultypage-module--grid--XNrA5";
export var gridCard = "facultypage-module--gridCard--r8JYr";
export var headerIcon = "facultypage-module--headerIcon--vjAwJ";
export var hide = "facultypage-module--hide--SiE8q";
export var hideOnMobile = "facultypage-module--hideOnMobile--PJH5M";
export var lightPinkBtn = "facultypage-module--lightPinkBtn--RIFu0";
export var list = "facultypage-module--list--MnbF2";
export var mainHeading = "facultypage-module--mainHeading--u8cBu";
export var pageHeading = "facultypage-module--pageHeading--50tGi";
export var pathIndicator = "facultypage-module--pathIndicator--K2jQb";
export var plusBtn = "facultypage-module--plusBtn--JXDFB";
export var rating = "facultypage-module--rating--s5gv8";
export var ratingContent = "facultypage-module--ratingContent--8ZxXV";
export var rotate = "facultypage-module--rotate--yoXXM";
export var sectionBody = "facultypage-module--sectionBody--678Ht";
export var sectionFooter = "facultypage-module--sectionFooter--bb30y";
export var sectionHeader = "facultypage-module--sectionHeader--uBc0-";
export var sectionHeadingName = "facultypage-module--sectionHeadingName--Mdyz3";
export var shareSection = "facultypage-module--shareSection--GGn0Q";
export var shawBtn = "facultypage-module--shawBtn--hE5b-";
export var showOnMobile = "facultypage-module--showOnMobile--vcyeU";
export var stickyButton = "facultypage-module--stickyButton--LZ7mc";
export var stickyInfo = "facultypage-module--stickyInfo--JCEza";
export var subHeading = "facultypage-module--subHeading--+TNQp";
export var subscriberBannerContainer = "facultypage-module--subscriberBannerContainer--Rga8q";
export var trailDay = "facultypage-module--trailDay--aogWK";